import { Decimal } from "classes/DecimalClasses";

import { i18n } from "services/i18nService";
import { formatDate } from "services/utility/dates";
import {
  formatCompanyWithContactInfo,
  formatBooleanYesOrBlank,
} from "services/utility/formatting";
import { starColumn } from "services/utility/schema";

import { INCH_UNIT, LB_UNIT } from "appConstants";

export const columnInfo = [
  starColumn,
  {
    name: "void",
    buttonLabel: i18n("columns.Void"),
    buttonAction: "void",
    isButton: true,
    fixed: true,
    excludeFromColumnList: true,
  },
  {
    name: "shipmentDate",
    heading: i18n("columns.ShipDate"),
    formatFunc: formatDate,
    defaultSort: true,
    sortDirection: "asc",
    sortable: true,
    fixed: true,
    fixedRightOfAction: true,
  },
  {
    name: "toAddress",
    heading: i18n("columns.To"),
    formatFunc: formatCompanyWithContactInfo,
    fixed: true,
    fixedRightOfAction: true,
    sortable: true,
  },
  {
    name: "fromAddress",
    heading: i18n("columns.From"),
    formatFunc: formatCompanyWithContactInfo,
    fixed: true,
    fixedRightOfAction: true,
    sortable: true,
  },
  {
    name: "shipmentIdentificationNumber",
    heading: i18n("columns.TrackingNumber"),
    sortable: true,
    fixed: true,
    fixedRightOfAction: true,
  },
  {
    name: "totalCharges",
    heading: i18n("columns.TotalCharges"),
    fixed: true,
    fixedRightOfAction: true,
  },
  {
    name: "voided",
    heading: i18n("columns.Voided"),
    formatFunc: formatBooleanYesOrBlank,
    sortable: true,
    fixed: true,
    fixedRightOfAction: true,
  },
];

export const LINE_ACTIONS = ["printLabel", "createReturnUpsShipment"];
export const BATCH_ACTIONS = ["printLabel"];

export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: ["weight"],
  MONEY_FIELDS: [],
  DATE_FIELDS: ["shipmentDate"],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};

export function getEmptyRecord() {
  return {
    location: null,
    fromAddress: {
      company: null,
      contact: null,
      address: {
        line1: null,
        line2: null,
        line3: null,
        city: null,
        stateProvince: null,
        postalCode: null,
      },
      phone: null,
      email: null,
    },
    fromResidentialAddress: false,
    toAddress: {
      company: null,
      contact: null,
      address: {
        line1: null,
        line2: null,
        line3: null,
        city: null,
        stateProvince: null,
        postalCode: null,
      },
      phone: null,
      email: null,
    },
    toResidentialAddress: false,
    packagingCode: null,
    refNumber: null,
    refNumber2: null,
    returnMerchandiseDescription: null,
    weightUnit: LB_UNIT,
    weight: Decimal.ZERO,
    declaredValue: Decimal.ZERO,
    dimensionUnit: INCH_UNIT,
    length: Decimal.ZERO,
    width: Decimal.ZERO,
    height: Decimal.ZERO,
    serviceCode: null,
    rateType: null,
    deliveryConfirmationCode: null,
    saturdayDelivery: false,
    additionalHandling: false,
    upsAccount: null,
  };
}

export const SHIPPING_TYPE_OPTIONS = [
  { id: "03", name: i18n("upsShipment.shippingOption.UpsGround") },
  { id: "01", name: i18n("upsShipment.shippingOption.UpsNextDayAir") },
  { id: "13", name: i18n("upsShipment.shippingOption.UpsNextDayAirSaver") },
  { id: "14", name: i18n("upsShipment.shippingOption.UpsNextDayAirEarlyAM") },
  { id: "02", name: i18n("upsShipment.shippingOption.Ups2ndDayAir") },
  { id: "59", name: i18n("upsShipment.shippingOption.Ups2ndDayAirAM") },
  { id: "12", name: i18n("upsShipment.shippingOption.Ups3DaySelect") },
  {
    id: "1001",
    name: i18n("upsShipment.shippingOption.UpsNextDayAirEarlySaturday"),
  },
  {
    id: "1002",
    name: i18n("upsShipment.shippingOption.UpsNextDayAirSaturday"),
  },
  { id: "1003", name: i18n("upsShipment.shippingOption.Ups2ndDayAirSaturday") },
];

export const CONFIRMATION_OPTIONS = [
  { id: "0", name: i18n("upsShipment.confirmationOption.Standard") },
  { id: "1", name: i18n("upsShipment.confirmationOption.Printed") },
  { id: "2", name: i18n("upsShipment.confirmationOption.SignatureRequired") },
  {
    id: "3",
    name: i18n("upsShipment.confirmationOption.AdultSignatureRequired"),
  },
];

export const RATE_OPTIONS = [
  { id: "53", name: i18n("upsShipment.rateOption.Standard") },
  { id: "01", name: i18n("upsShipment.rateOption.Daily") },
  { id: "04", name: i18n("upsShipment.rateOption.Retail") },
];
export const PACKAGE_TYPE_OPTIONS = [
  { id: "02", name: i18n("upsShipment.packageOption.YourPackaging") },
  { id: "01", name: i18n("upsShipment.packageOption.UPSLetter") },
  { id: "03", name: i18n("upsShipment.packageOption.Tube") },
  { id: "04", name: i18n("upsShipment.packageOption.PAK") },
  { id: "21", name: i18n("upsShipment.packageOption.UPSExpressBox") },
  { id: "30", name: i18n("upsShipment.packageOption.Pallet") },
  { id: "2a", name: i18n("upsShipment.packageOption.SmallExpressBox") },
  { id: "2b", name: i18n("upsShipment.packageOption.MediumExpressBox") },
  { id: "2c", name: i18n("upsShipment.packageOption.LargeExpressBox") },
];
